const Acl = {
    install(Vue, options) {
        // If ownerId id is equal to current userId permission is always granted
        Vue.prototype.$can = function (permission, ownerId = false) {
            if (typeof window.AshnetApp.userId !== 'undefined' && window.AshnetApp.userId !== false && window.AshnetApp.userId == ownerId) {
                return true;
            }
            if (window.AshnetApp.permissions.indexOf(permission)!==-1) {
                return true;
            }
            return false;
        }
    }
};
module.exports = Acl;

window.AshnetApp.can = function (permission, ownerId = false) {
    if (typeof window.AshnetApp.userId !== 'undefined' && window.AshnetApp.userId !== false && window.AshnetApp.userId == ownerId) {
        return true;
    }
    if (window.AshnetApp.permissions.indexOf(permission)!==-1) {
        return true;
    }
    return false;
}


window.AshnetApp.currTeam = function () {
    if (typeof window.AshnetApp.currentTeamId !== 'undefined' && window.AshnetApp.userId !== false) {
        return window.AshnetApp.currentTeamId;
    }else{
        return 0;
    }
}
